import type { TFunction } from 'i18next';
import { object, string } from 'yup';

export const getValidationSchema = (t: TFunction) =>
  object().shape({
    first_name: string().trim().required(t('First Name is required')),
    last_name: string().trim().required(t('Last Name is required')),
    email_address: string().email(t('Please enter a valid email address')).required(t('Email is required')),
  });
